enum CheckboxFieldActionType {
    DISPLAY_CHECKBOX_FIELD_ERROR = "DISPLAY_CHECKBOX_FIELD_ERROR",
    UPDATE_CHECKBOX_FIELD_VALUE = "UPDATE_CHECKBOX_FIELD_VALUE",
    RESET_CHECKBOX_FIELD = "RESET_CHECKBOX_FIELD",
}

export default CheckboxFieldActionType;
